module.exports = require('@emotion/styled');
